import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  isLoadingExcel: false,
  successMessage: null,
  errorMessage: null,
  reportModels: [],
  reportModelsTotalElements: 0,
  createdId: null,
  eventReport: [],
  eventReportTotalElements: 0,
  eventReportForExcel: [],
  webSocketEvents: [],
});

const { Types, Creators } = createActions({
  getReportModelsRequest: ['pageParams'],
  getReportModelsRequestSuccess: ['reportModels', 'reportModelsTotalElements'],
  getReportModelsRequestFailure: ['errorMessage'],

  createReportModelRequest: ['reportModelInfos', 'pageParams'],
  createReportModelRequestSuccess: ['createdId', 'reportModels', 'reportModelsTotalElements', 'successMessage'],
  createReportModelRequestFailure: ['errorMessage'],

  editReportModelRequest: ['reportModelInfos', 'pageParams'],
  editReportModelRequestSuccess: ['reportModels', 'reportModelsTotalElements', 'successMessage'],
  editReportModelRequestFailure: ['errorMessage'],

  deleteReportModelRequest: ['reportModelId', 'pageParams'],
  deleteReportModelRequestSuccess: ['reportModels', 'reportModelsTotalElements', 'successMessage'],
  deleteReportModelRequestFailure: ['errorMessage'],

  getEventReportRequest: ['customerId', 'filters', 'params'],
  getEventReportRequestSuccess: ['eventReport', 'eventReportTotalElements'],
  getEventReportRequestFailure: ['errorMessage'],

  getEventReportForExcel: ['customerId', 'filters', 'params'],
  getEventReportForExcelSuccess: ['eventReportForExcel'],
  getEventReportForExcelFailure: ['errorMessage'],

  addWebSocketEvent: ['singleEvent'],
  clearWebSocketEvents: null,
});

export const getReportModelsRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getReportModelsRequestSuccess = (state, { reportModels, reportModelsTotalElements }) =>
  state.merge({ isLoading: false, reportModels, reportModelsTotalElements });
export const getReportModelsRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const createReportModelRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const createReportModelRequestSuccess = (
  state,
  { createdId, reportModels, reportModelsTotalElements, successMessage }
) => state.merge({ isLoading: false, createdId, reportModels, reportModelsTotalElements, successMessage });
export const createReportModelRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const editReportModelRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const editReportModelRequestSuccess = (state, { reportModels, reportModelsTotalElements, successMessage }) =>
  state.merge({ isLoading: false, reportModels, reportModelsTotalElements, successMessage });
export const editReportModelRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const deleteReportModelRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const deleteReportModelRequestSuccess = (state, { reportModels, reportModelsTotalElements, successMessage }) =>
  state.merge({ isLoading: false, reportModels, reportModelsTotalElements, successMessage });
export const deleteReportModelRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const getEventReportRequest = (state) =>
  state.merge({ isLoading: true, successMessage: null, errorMessage: null });
export const getEventReportRequestSuccess = (state, { eventReport, eventReportTotalElements }) =>
  state.merge({ isLoading: false, eventReport, eventReportTotalElements });
export const getEventReportRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const getEventReportForExcel = (state) =>
  state.merge({ isLoadingExcel: true, successMessage: null, errorMessage: null });
export const getEventReportForExcelSuccess = (state, { eventReportForExcel }) =>
  state.merge({ isLoadingExcel: false, eventReportForExcel });
export const getEventReportForExcelFailure = (state, { errorMessage }) =>
  state.merge({ isLoadingExcel: false, errorMessage });

export const addWebSocketEvent = (state, { singleEvent }) => {
  const newWebSocketEvents = [...state.webSocketEvents, singleEvent]
  return state.merge({ webSocketEvents: newWebSocketEvents })
}
export const clearWebSocketEvents = (state) => state.merge({ webSocketEvents: [] })

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_REPORT_MODELS_REQUEST]: getReportModelsRequest,
  [Types.GET_REPORT_MODELS_REQUEST_SUCCESS]: getReportModelsRequestSuccess,
  [Types.GET_REPORT_MODELS_REQUEST_FAILURE]: getReportModelsRequestFailure,

  [Types.CREATE_REPORT_MODEL_REQUEST]: createReportModelRequest,
  [Types.CREATE_REPORT_MODEL_REQUEST_SUCCESS]: createReportModelRequestSuccess,
  [Types.CREATE_REPORT_MODEL_REQUEST_FAILURE]: createReportModelRequestFailure,

  [Types.EDIT_REPORT_MODEL_REQUEST]: editReportModelRequest,
  [Types.EDIT_REPORT_MODEL_REQUEST_SUCCESS]: editReportModelRequestSuccess,
  [Types.EDIT_REPORT_MODEL_REQUEST_FAILURE]: editReportModelRequestFailure,

  [Types.DELETE_REPORT_MODEL_REQUEST]: deleteReportModelRequest,
  [Types.DELETE_REPORT_MODEL_REQUEST_SUCCESS]: deleteReportModelRequestSuccess,
  [Types.DELETE_REPORT_MODEL_REQUEST_FAILURE]: deleteReportModelRequestFailure,

  [Types.GET_EVENT_REPORT_REQUEST]: getEventReportRequest,
  [Types.GET_EVENT_REPORT_REQUEST_SUCCESS]: getEventReportRequestSuccess,
  [Types.GET_EVENT_REPORT_REQUEST_FAILURE]: getEventReportRequestFailure,

  [Types.GET_EVENT_REPORT_FOR_EXCEL]: getEventReportForExcel,
  [Types.GET_EVENT_REPORT_FOR_EXCEL_SUCCESS]: getEventReportForExcelSuccess,
  [Types.GET_EVENT_REPORT_FOR_EXCEL_FAILURE]: getEventReportForExcelFailure,

  [Types.ADD_WEB_SOCKET_EVENT]: addWebSocketEvent,
  [Types.CLEAR_WEB_SOCKET_EVENTS]: clearWebSocketEvents,
});

export const EventReportsTypes = Types;
export default Creators;
